import React from "react";
import Header from "../Layout/Header";
import Box from "@mui/material/Box";
import DocumentResultView from "./DocumentResultView";

import { useMediaQuery } from "@mui/material";

import { useTheme } from "@mui/material/styles";

export default function Dashboard() {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
            <Header />

            {/* Aviso mobile fixo no rodapé */}
            {isMobile && (
                <Box
                    sx={{
                        width: "90%",
                        bgcolor: theme.palette.warning.light,
                        color: theme.palette.warning.contrastText,
                        textAlign: "center",
                        py: 1.5,
                        px: 2,
                        borderRadius: 2,
                        mt: 2,
                        mb: -1.5,
                        ml: "auto",
                        mr: "auto",
                        fontWeight: 600,
                        fontSize: 14,
                    }}
                >
                    ⚠️ Para uma melhor experiência e acesso completo a todos os recursos, recomendamos o uso em computador (desktop).
                </Box>
            )}


            <Box sx={{ p: { xs: 1, sm: 3 }, width: "100%", mx: "auto" }}>
                <DocumentResultView />
            </Box>
        </>
    );
}